module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "team",
    style: ({
      height: _vm.height
    })
  }, [_c('b-header', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage !== 0 && Math.abs(_vm.scrollTop) < 100),
      expression: "currentPage !== 0 && Math.abs(scrollTop) < 100"
    }],
    staticClass: "sub_nav"
  })]), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "container",
    on: {
      "mousewheel": _vm.mousewheel,
      "wheel": _vm.mousewheel
    }
  }, [(!_vm.isMobi) ? _c('div', {
    staticClass: "page pc",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "line"
  })]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].title))])]), _c('transition', {
    attrs: {
      "name": "bottom-in-delay"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }]
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.turnTo(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].iteam))]), _c('li', {
    on: {
      "click": function($event) {
        return _vm.turnTo(1, 2)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].piteam))])])])], 1), _c('div', {
    staticClass: "movie"
  }, [_c('video', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.isMobi ? require('../assets/team_mobi.mp4') : require('../assets/team.mp4'),
      "autoplay": "autoplay",
      "loop": "loop"
    },
    on: {
      "mouseenter": _vm.movieEnter,
      "mouseleave": _vm.movieLeave
    }
  })])]) : _vm._e(), _c('div', {
    ref: "iteam",
    staticClass: "page",
    style: ({
      overflowY: 'scroll'
    }),
    on: {
      "mousewheel": function($event) {
        $event.stopPropagation();
        return _vm.sub_mousewheel_iteam.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "nav mobi"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "line"
  })]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].title))])]), _c('transition', {
    attrs: {
      "name": "bottom-in-delay"
    }
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }]
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.turnTo(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].iteam))]), _c('li', {
    on: {
      "click": function($event) {
        return _vm.turnTo(1, 2)
      }
    }
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].piteam))])])])], 1), _vm._m(0), _c('div', {
    staticClass: "sub_title"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animateCtrl[1 - !!_vm.isMobi]),
      expression: "animateCtrl[1 - !!isMobi]"
    }]
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].iteam))])])], 1), _c('div', {
    staticClass: "peoples"
  }, _vm._l((_vm.iteamList), function(item, index) {
    return _c('div', {
      staticClass: "people",
      on: {
        "mouseenter": function($event) {
          return _vm.hover(index)
        },
        "mouseleave": _vm.leave,
        "click": function($event) {
          $event.stopPropagation();
          return _vm.slideDownA(index)
        }
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": item.avatar
      }
    }), _c('transition', {
      attrs: {
        "name": "bottom-in"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.animateCtrl[1 - !!_vm.isMobi]),
        expression: "animateCtrl[1 - !!isMobi]"
      }],
      staticClass: "text",
      on: {
        "mousemove": function($event) {
          return _vm.hover(index)
        },
        "mouseleave": _vm.leave
      }
    }, [_c('div', {
      staticClass: "job-title"
    }, [_vm._v(_vm._s(item.jobTitle))]), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.title))])])]), _c('transition', {
      attrs: {
        "appear": "appear"
      },
      on: {
        "before-enter": _vm.beforeEnter,
        "enter": _vm.enter,
        "leave": _vm.leaves
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.openIndexA == index),
        expression: "openIndexA == index"
      }],
      staticClass: "descs"
    }, [_c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "introduction"
    }, [_vm._v(_vm._s(_vm.langs[_vm.lang].introduction) + ":")]), _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _c('div', {
      staticClass: "contact"
    }, [_c('div', {
      staticClass: "email"
    }, [_vm._v(_vm._s(item.email))]), _c('div', {
      staticClass: "wechat"
    }, [_vm._v(_vm._s(item.wechat))])])]), _c('div', {
      staticClass: "close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.close.apply(null, arguments)
        }
      }
    }, [_c('span', {
      staticClass: "iconfont"
    }, [_vm._v("")]), _vm._v("close")])])])], 1)
  }), 0), _c('div', {
    staticClass: "sub_title"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.animateCtrl[1 - !!_vm.isMobi]),
      expression: "animateCtrl[1 - !!isMobi]"
    }]
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].piteam))])])], 1), _c('div', {
    staticClass: "peoples"
  }, _vm._l((_vm.piteamList), function(item, index) {
    return _c('div', {
      staticClass: "people",
      on: {
        "mousemove": function($event) {
          return _vm.hover(index)
        },
        "click": function($event) {
          $event.stopPropagation();
          return _vm.slideDownB(index)
        },
        "mouseleave": _vm.leave
      }
    }, [_c('img', {
      staticClass: "avatar",
      attrs: {
        "src": item.avatar
      }
    }), _c('transition', {
      attrs: {
        "name": "bottom-in"
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.animateCtrl[1 - !!_vm.isMobi]),
        expression: "animateCtrl[1 - !!isMobi]"
      }],
      staticClass: "text",
      on: {
        "mousemove": function($event) {
          return _vm.hover(index)
        },
        "mouseleave": _vm.leave
      }
    }, [_c('div', {
      staticClass: "job-title"
    }, [_vm._v(_vm._s(item.jobTitle))]), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.title))])])]), _c('transition', {
      attrs: {
        "appear": "appear"
      },
      on: {
        "before-enter": _vm.beforeEnter,
        "enter": _vm.enter,
        "leave": _vm.leaves
      }
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.openIndexB == index),
        expression: "openIndexB == index"
      }],
      staticClass: "descs"
    }, [_c('div', {
      staticClass: "desc"
    }, [_c('div', {
      staticClass: "introduction"
    }, [_vm._v(_vm._s(_vm.langs[_vm.lang].introduction) + ":")]), _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _c('div', {
      staticClass: "contact"
    }, [_c('div', {
      staticClass: "email"
    }, [_vm._v(_vm._s(item.email))]), _c('div', {
      staticClass: "wechat"
    }, [_vm._v(_vm._s(item.wechat))])])]), _c('div', {
      staticClass: "close",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.close.apply(null, arguments)
        }
      }
    }, [_c('span', {
      staticClass: "iconfont"
    }, [_vm._v("")]), _vm._v("close")])])])], 1)
  }), 0)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "photo mobi"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/team/total.jpg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-180d17e8","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/team.vue
// module id = 504
// module chunks = 1